// @ts-ignore
const tg : any=  window?.Telegram?.WebApp

export function useTelegram() {

    return {
        tg
    }
}